import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';

import 'rxjs/add/operator/toPromise';
import { GlobalVariable } from './../shared/global';

@Injectable()
export class ServiceAvailabilityService {
  // private baseApiUrl = GlobalVariable.BASE_API_URL;
  private headers = new Headers({'Content-Type': 'application/json'});
  // private get_tdu_url = this.baseApiUrl + 'api/rest/v1/enroll/check/tdu/';
  // private get_google_tdu_url = this.baseApiUrl + 'api/rest/v1/street/tdu/search/';
  // private get_tdu_sg_url = this.baseApiUrl + 'api/rest/v1/tdusg/';
  constructor(private http: Http) { }

  // getTDUs(address: Object) {
  //   return this.http.post(this.get_tdu_url, address)
  //              .toPromise()
  //              .then(response => response.json())
  //              .catch(this.handleError);
  // }

  // getTDUsFromSG(address: string, zipcode: string): Promise<any> {
  //   console.log(this.get_tdu_sg_url + address + '/' + zipcode + '/');
  //   return this.http.get(this.get_tdu_sg_url + address + '/' + zipcode + '/')
  //              .toPromise()
  //              .then(response => response.json())
  //              .catch(this.handleError);
  // }

  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error);
    return Promise.reject(error.message || error);
  }

}



// WEBPACK FOOTER //
// ./src/app/service-availability/service-availability.service.ts